//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.ChangeMessage
import com.tixforgigs.apax.models.PaymentTypeId
import com.tixforgigs.apax.models.ShoppingCart
import com.tixforgigs.apax.models.TermsAndConditions

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The cart response model
* 
* @param guestCheckout is anonymous checkout possible
* @param personalizationRequired is personalization required
* @param shoppingCart 
* @param upsellingPossible is upselling possible
* @param availablePaymentTypes The available payment methods
* @param emailAddress The user email (and login username)
* @param messages may contain additional data for the cart, e.g. changed extraConfig after a floorplan-request or productDisplayState after a failed cart add request
* @param missingAgeRestrictionShoppingCartIds The list of age-restricted cart item ids.
* @param properties may contain additional data for the cart, e.g. changed extraConfig after a floorplan-request or productDisplayState after a failed cart add request
* @param termsAndConditions The list of terms and conditions
*/
@Serializable

data class CartResponse (


      /* is anonymous checkout possible */
    @SerialName(value = "guestCheckout") @Required val guestCheckout: kotlin.Boolean,


      /* is personalization required */
    @SerialName(value = "personalizationRequired") @Required val personalizationRequired: kotlin.Boolean,


      @SerialName(value = "shoppingCart") @Required val shoppingCart: ShoppingCart,


      /* is upselling possible */
    @SerialName(value = "upsellingPossible") @Required val upsellingPossible: kotlin.Boolean,


      /* The available payment methods */
    @SerialName(value = "availablePaymentTypes") val availablePaymentTypes: kotlin.collections.List<PaymentTypeId>? = null,


      /* The user email (and login username) */
    @SerialName(value = "emailAddress") val emailAddress: kotlin.String? = null,


      /* may contain additional data for the cart, e.g. changed extraConfig after a floorplan-request or productDisplayState after a failed cart add request */
    @SerialName(value = "messages") val messages: kotlin.collections.List<ChangeMessage>? = null,


      /* The list of age-restricted cart item ids. */
    @SerialName(value = "missingAgeRestrictionShoppingCartIds") val missingAgeRestrictionShoppingCartIds: kotlin.collections.List<kotlin.uuid.Uuid>? = null,


      /* may contain additional data for the cart, e.g. changed extraConfig after a floorplan-request or productDisplayState after a failed cart add request */
    @Deprecated(message = "This property is deprecated.")
    @SerialName(value = "properties") val properties: kotlinx.serialization.json.JsonObject? = null,


      /* The list of terms and conditions */
    @SerialName(value = "termsAndConditions") val termsAndConditions: kotlin.collections.List<TermsAndConditions>? = null


) {




  }

